module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "collectData"
    }
  }, [_c('HeadControl', {
    ref: "headControl",
    attrs: {
      "titleName": '汇总数据'
    },
    on: {
      "changeVal": _vm.changeVal,
      "changDate": _vm.changDate,
      "changePicker": _vm.changePicker
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "top-Box"
  }, [_c('div', {
    staticClass: "left"
  }, _vm._l((_vm.reportList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "left-t"
    }, [_c('div', {
      staticClass: "icon"
    }, [_c('img', {
      attrs: {
        "src": item.itemIcon
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "desc"
    }, [_c('div', {
      staticClass: "a-title"
    }, [_vm._v(_vm._s(item.itemName))]), _vm._v(" "), (item.itemName.includes('金额')) ? _c('div', {
      staticClass: "amount"
    }, [_vm._v(_vm._s(_vm.aFormat(item.amount))), _c('span', [_vm._v("元")])]) : _vm._e(), _vm._v(" "), (item.itemName.includes('数量')) ? _c('div', {
      staticClass: "amount"
    }, [_vm._v(_vm._s(item.count)), _c('span', [_vm._v("个")])]) : _vm._e()])])
  }), 0), _vm._v(" "), _c('div', {
    ref: "ProgressProportion",
    staticClass: "Progress"
  }), _vm._v(" "), _c('div', {
    staticClass: "sendOrdersBox"
  }, [_c('div', {
    ref: "SendOrders",
    staticClass: "sendOrders"
  }), _vm._v(" "), (_vm.Judge) ? _c('div', {
    staticClass: "nodata_box"
  }, [_c('img', {
    attrs: {
      "src": "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/report_item_nodata.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("暂无数据")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-Box"
  }, [_c('div', {
    staticClass: "left-Box"
  }, [_c('div', {
    staticClass: "lOne-box"
  }, [_c('div', {
    staticClass: "BoxText"
  }, [_vm._v("项目地区")]), _vm._v(" "), _c('div', {
    staticClass: "regionData"
  }, _vm._l((_vm.RegionDataList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "BoxData"
    }, [_c('div', {
      staticClass: "SmBoxData"
    }, [_c('div', {
      staticClass: "region"
    }, [_vm._v(_vm._s(item.itemName))]), _vm._v(" "), _c('div', {
      staticClass: "number"
    }, [_vm._v(_vm._s(item.count)), _c('i', [_vm._v("个")])])]), _vm._v(" "), _c('div', {
      staticClass: "DataImg"
    }, [_c('img', {
      attrs: {
        "src": item.itemIcon,
        "alt": ""
      }
    })])])
  }), 0)]), _vm._v(" "), _c('div', {
    ref: "schedule",
    staticClass: "schedule"
  })]), _vm._v(" "), _c('div', {
    ref: "ProjectLevel",
    staticClass: "right-Box"
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70d36a68"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/engineeringData/collectData.vue
// module id = 1676
// module chunks = 471